import { createAction } from 'redux-actions';

import {
	GET_REGISTRATION_LINK_STATUS_CALL,
	GET_REGISTRATION_LINK_STATUS_DONE,
	GET_REGISTRATION_LINK_STATUS_FAIL,
	RESET_REGISTRATION_LINK_STATUS,
	POST_CREATE_REGISTRATION_EMAIL_USER_CALL,
	POST_CREATE_REGISTRATION_EMAIL_USER_DONE,
	POST_CREATE_REGISTRATION_EMAIL_USER_FAIL,
	POST_CREATE_REGISTRATION_MOBILE_USER_CALL,
	POST_CREATE_REGISTRATION_MOBILE_USER_DONE,
	POST_CREATE_REGISTRATION_MOBILE_USER_FAIL,
	POST_REGISTER_REGISTRATION_LINK_USER_CALL,
	POST_REGISTER_REGISTRATION_LINK_USER_DONE,
	POST_REGISTER_REGISTRATION_LINK_USER_FAIL,
	POST_REGISTRATION_LINK_LOGIN_VERIFY_CALL,
	POST_REGISTRATION_LINK_LOGIN_VERIFY_DONE,
	POST_REGISTRATION_LINK_LOGIN_VERIFY_FAIL,
} from '@src/store/types';

export const getRegistrationLinkStatusCall = createAction(GET_REGISTRATION_LINK_STATUS_CALL);
export const getRegistrationLinkStatusDone = createAction(GET_REGISTRATION_LINK_STATUS_DONE);
export const getRegistrationLinkStatusFail = createAction(GET_REGISTRATION_LINK_STATUS_FAIL);
export const resetRegistrationLinkStatus = createAction(RESET_REGISTRATION_LINK_STATUS);

export const postCreateRegistrationEmailUserCall = createAction(POST_CREATE_REGISTRATION_EMAIL_USER_CALL);
export const postCreateRegistrationEmailUserDone = createAction(POST_CREATE_REGISTRATION_EMAIL_USER_DONE);
export const postCreateRegistrationEmailUserFail = createAction(POST_CREATE_REGISTRATION_EMAIL_USER_FAIL);

export const postCreateRegistrationMobileUserCall = createAction(POST_CREATE_REGISTRATION_MOBILE_USER_CALL);
export const postCreateRegistrationMobileUserDone = createAction(POST_CREATE_REGISTRATION_MOBILE_USER_DONE);
export const postCreateRegistrationMobileUserFail = createAction(POST_CREATE_REGISTRATION_MOBILE_USER_FAIL);

export const postRegisterRegistrationLinkUserCall = createAction(POST_REGISTER_REGISTRATION_LINK_USER_CALL);
export const postRegisterRegistrationLinkUserDone = createAction(POST_REGISTER_REGISTRATION_LINK_USER_DONE);
export const postRegisterRegistrationLinkUserFail = createAction(POST_REGISTER_REGISTRATION_LINK_USER_FAIL);

export const postRegistrationLinkLoginVerifyCall = createAction(POST_REGISTRATION_LINK_LOGIN_VERIFY_CALL);
export const postRegistrationLinkLoginVerifyDone = createAction(POST_REGISTRATION_LINK_LOGIN_VERIFY_DONE);
export const postRegistrationLinkLoginVerifyFail = createAction(POST_REGISTRATION_LINK_LOGIN_VERIFY_FAIL);
